import { KeyboardEventHandler } from 'react'

export const formEnterPrevent: KeyboardEventHandler<HTMLFormElement> = e => {
  if (e.code === 'Enter' || e.code === 'NumpadEnter') {
    e.preventDefault()
  }
}
